<template>
  <div class="phone-index customer">
    <div class="title-box">
      <i class="iconfont iconchakangengduojiantou"></i>
      <span class="text1">客户详情</span>
    </div>
    <div class="empty-box" style="height:70px">客户基本信息</div>
    <div class="empty-box" style="height:60px">日程提醒</div>
    <draggable v-model="list" class="tools-list" @update="sortEvent" v-if="list.length" @drop.native.stop>
      <div class="tools-item" v-for="(bean,i) in list" :key="i">
        <img :src="bean.img" alt="">
        <span class="text">{{bean.name}}</span>
      </div>
    </draggable>
    <div class="empty-box" style="height:345px">客户详细信息</div>
    <div class="bottom-box">
      <div class="btn1">编辑详细资料</div>
      <div class="btn2">去托管</div>
      <div class="btn3">联系客户</div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import phoneNav from "./phoneNav";
export default {
  components: {
    draggable,
    phoneNav,
  },
  mixins:[],
  props: {
  },
  data() {
    return {
      list:[],
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
  },
  methods: {
    setData(list){
      this.list = list.filter(item=>{
        return item.enable==1
      });;
    },
    sortEvent(){
      const ids = this.list.map(item=>{
        return item.id;
      })
      this.$http({
        url: "/buz/mcmMerchantModule/updateRank",
        type: "POST",
        data: {
          ids:ids.join(',')
        }
      }).then((res)=>{
        this.$emit("sort", this.list);
      })
    },
  },

};
</script>
<style lang="scss" scoped>
@import "./phoneIndex.scss";
</style>
